// import Layout from "../components/layout";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { io } from "socket.io-client";

import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { MdAddPhotoAlternate } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import DOMPurify from "dompurify";
// import { BsEmojiSmileFill } from "react-icons/bs";
// import Picker from "emoji-picker-react";
import { FaRegUser } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";
import {GetTimeAgo} from "../components/GetTime.js"
import { GetDate} from "../components/GetDate.js"
import nopreview from "../assets/images/no-preview.png"
import { jwtDecode } from 'jwt-decode';
import config from "../config";

const aws = require("aws-sdk");

const Chats = (data) => {

  const token = localStorage.getItem("token");
 const decoded = jwtDecode(token);
  const userData = decoded.data.customer_data;
  
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [imageLoading, setImageLoading] = useState(false);
  const API_BASE_URL = config.API_BASE_URL;
  // const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  // const handleEmojiPickerhideShow = (e) => {
  //   const emojiButton = document.querySelector(".emoji");
  //   if (emojiButton.contains(e.target)) {
  //     setShowEmojiPicker(!showEmojiPicker);
  //   } else {
  //     setShowEmojiPicker(false);
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", handleEmojiPickerhideShow);
  //   return () => {
  //     document.removeEventListener("click", handleEmojiPickerhideShow);
  //   };
  // }, []);


  const handleEmojiClick = (e, emojiObject) => {
    setInputValue((prevInputValue) => prevInputValue + e.emoji);
  };

  // const senderName = data?.data?.senderName;
  const receiverName = data?.data?.receiverName;
  const senderId = data?.data?.senderId;
  const receiverId = data?.data?.receiverId;
  const selectedChatImage = data?.data?.selectedChatImage;

  const [imagePop, setImagePop] = useState(false);

  const chatContainerRef = useRef(null);

  useEffect(() => {
    setRemoteDescriptionSet(true);
    const fetchMessages = async () => {
      const payload = {};
      const config = {
        url: `${API_BASE_URL}/chat/getMessagesforcustomer?customerId=${senderId}&sellerId=${receiverId}`,
        method: "GET",
        maxBodyLength: Infinity,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        
      };
      try {
        const response = await axios.request(config);
        const data = await response.data;
       // console.log(response.data[0].content);
        setMessages(response.data[0].content);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    };

    fetchMessages();
  }, [receiverId]);

  useEffect(() => {
    
    socket.on("receive-message", handleReceivedMessage);

    return () => {
      socket.off("receive-message", handleReceivedMessage);
    };
  }, []);

  const handleReceivedMessage = (newMessage) => {
    setMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if ((inputValue&& !imageUrl)||imageUrl) {
      try {
        const response = await axios.post(`${API_BASE_URL}/chat/createmessage`, {
          customerId:senderId,
          sellerId:receiverId,
          message: inputValue,
          media: imageUrl,
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          "sender": "customer",
          "receiver": "seller",
        });
        const newMessage = {
          _id: response.data.message._id,  // Assuming the response contains the new message data
          message: inputValue,
          media: imageUrl,
          sender: "customer",
          receiver: "seller",
          senderId:senderId,
          receiverId:receiverId,
          createdAt: new Date().toISOString(),
        };

        setMessages([...messages, newMessage]);
        socket.emit('send-message', newMessage);
        setRemoteDescriptionSet(true);
        setInputValue('');
        const pathname = new URL(imageUrl).pathname;
        pathname.substring(pathname.lastIndexOf('/') + 1); 
        const senddoc = await axios.post(`${API_BASE_URL}/clientpet/uploadMessageDocs`, {
          customerId:senderId,
          sellerId:receiverId,
          messageUrl: imageUrl,
          docName: pathname,
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        });
        

        setImageUrl('');
        setImagePop(false);
        console.log(
          "get all the message ------------------>",
          inputValue
        );
        setInputValue("");
      } catch (error) {
        console.error("Error sending message:", error);
      }
    }
  };

  useEffect(() => {
    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
  }, [messages]);

  const handleUpload = async (imageType, send_img) => {
    setImageLoading(true);
    setImagePop(false);
    setImageUrl(send_img);
    try {
      const updatedData = {
        [imageType]: send_img,
      };
      const response = await axios.put(
        `${API_BASE_URL}/user/update/${userData?._id}`,
        updatedData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        setImageLoading(false);
        setImagePop(false);
        toast.success("Image Uploaded Successfully", {position:"top-center"});
      } else {
        toast.error("Failed to Image Uploaded" , {position:"top-center"});
      }
    } catch (error) {
      console.error("Image Uploaded error", error);
    }
  };

  const ImageHandler = async (e) => {
    setImageLoading(true);
    try {
      const file = e.target.files[0];
      let myFile = file.name.split(".");
      let myFileType = myFile[myFile.length - 1];
      const s3 = new aws.S3({
        accessKeyId: config.AWS_KEY_ID,
        secretAccessKey: config.AWS_SECRET_KEY,
      });
      const params = {
        Bucket: "finlocalpetchat",
        Key: `${uuidv4()}.${myFileType}`,
        Body: file,
        ContentType: file?.type,
      };
      let { Location } = await s3.upload(params).promise();
      setImageLoading(false);
      return Location;
    } catch (exception) {
      console.error(exception);
      return false;
    } finally {
    }
  };

  const setImage = async (e) => {
    const image = await ImageHandler(e);

    if (image) {
      setImageUrl(image);
      //await handleUpload("post_img", image);
    }
  };

  const isVideoExtension = (url) => {
    if (!url) return false;
    const videoExtensions = [".mp4", ".webm", ".ogg"];
    const videoExtensionchange = videoExtensions.toString();
    const extension = getExtension(url);
    const myurl = videoExtensionchange.includes(extension);
    return myurl;
  };
  const isPdfExtension=(url)=>{
    if (!url) return false;
    const pdfExtensions = [".pdf"];
    const pdfExtensionchange = pdfExtensions.toString();
    const extension = getExtension(url);
    const myurl = pdfExtensionchange.includes(extension);
    return myurl;
  }

  const getExtension = (url) => {
    return url.split(".").pop().toLowerCase();
  };

  const [remoteDescriptionSet, setRemoteDescriptionSet] = useState(false);

  const socket = io(API_BASE_URL, {
    transports: ["websocket", "polling"],
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  useEffect(() => {
    socket.emit("register", userData.id);

    socket.on("connect", () => {
      console.log("Connected to the server");
    });

    socket.on("receive-message", (newMessage) => {
      handleReceivedMessage(newMessage);
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from the server");
    });

    return () => {};
  }, [remoteDescriptionSet]);

  return (
    <div className="flex flex-col items-center justify-between h-full w-full filter">
      <div
        className="flex flex-row py-3 px-2 items-center border-b-2 bg-white w-full cursor-pointer"
        onClick={null}
      >
        <button onClick={data?.data?.handleBackToChatList} className="ddd">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        {selectedChatImage && selectedChatImage.length > 0 ? (
          <div className="mx-1 border-[1px] border-gray-500 rounded-full p-1">
            <img
              src={selectedChatImage}
              className="object-cover sm:h-11 sm:w-14 w-20 h-11 rounded-full border-[1px] border-gray-500"
              alt="profile image"
            />
          </div>
        ) : (
          <div className="mr-3 border-[1px] border-gray-500 rounded-full p-1">
            <p className="w-12 h-12 flex items-center justify-center rounded-full border border-gray-500 p-1 font-bold text-uppercase bg-slate-300">
              {receiverName?.charAt(0).toUpperCase()}
            </p>
          </div>
        )}
        <div className="w-full">
          <h5 className="text-lg font-semibold sm:w-full w-40 overflow-hidden text-ellipsis whitespace-nowrap">
            {receiverName}
          </h5>
          <p className="text-gray-500 text-xs sm:w-full w-36 overflow-hidden text-ellipsis whitespace-nowrap">
            {`Hi ${receiverName}, Welcome `}
            <span className="text-gray-700 text-xs font-semibold">{}</span>
          </p>
        </div>
      </div>
      <div
        ref={chatContainerRef}
        className="flex flex-col gap-2 w-full p-4 overflow-y-scroll overflow-x-hidden md:max-h-[600px] md:h-auto h-[420px]"
        
      >
        <div className="chat-container">
          {messages.map((message) => {
            const sanitizedContent = DOMPurify.sanitize(message.message);
            console.log(message)
            const isSender = message.sender === "seller";
            const messageClasses = `relative max-w-72 min-w-20 rounded-[30px] ${
              isSender
                ? "self-end bg-[#FFC70040] mr-3 text-black"
                : "self-start bg-[#ECF7FF]  text-left ml-3 text-black"
            }`;
            const triangleClasses = `absolute ${
              isSender
                ? "right-0 bottom-[-10px] mx-auto h-0 w-0 border-r-31p border-b-35p border-t-35p border-solid border-r-transparent border-l-transparent border-b-[#000] rotate-90 border-gray-200"
                : "left-0 bottom-[-10px] mx-auto h-0 w-0 border-r-31p border-b-35p border-t-35p border-solid border-r-transparent border-l-transparent border-b-[#000] border-t-[17px] border-r-[17px] transform rotate-0 border-blue-500"
            } border-solid border-t-[17px] border-r-[17px] h-0 w-0 transform`;

            return (
              <div
                key={message?._id}
                className={`flex my-4 ${
                  isSender ? "justify-start" : "justify-end"
                }`}
              >
                <div >
                  <div className={`mb-1 ${messageClasses}`}>
                    {message.media && (
                      <div className="rounded-xl m-2 p-1">
                        {isVideoExtension(message.media) ? (
                          <video
                            className="w-auto h-auto rounded-lg relative m-auto"
                            controls
                            autoPlay
                            loop
                            muted
                          >
                            <source
                              src={message.media}
                              type="video/mp4"
                              alt="video"
                            />
                            Your browser does not support the video tag.
                          </video>
                        ) 
                        
                        : isPdfExtension(message.media) ? (
                          
      <div className="flex flex-col items-center justify-center">
      <img
                  src={nopreview} // Display the first page image or a placeholder if the PDF image couldn't be generated
                  alt={`PDF Document`}
                  className="w-full h-32 object-cover cursor-pointer"
                  onClick={() => window.open(message.media, "_blank")}
                />
       
      </div>
    ): (
                          <img
                            src={message.media}
                            alt="image"
                            className="w-auto h-auto rounded-lg relative m-auto"
                          />
                        )}
                        <div
                          className="w-3/4 text-center"
                          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                        />
                      </div>
                    )}
                    {!message.media && (
                      <div
                        className="m-4 p-1"
                        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                      />
                    )}
                  </div>
            
                  <p
                    className={`text-xs ${
                      isSender
                        ? "text-left  ml-4"
                        : "text-right mr-2"
                    }`}
                  >
                    <span className="align-middle">
                      {GetTimeAgo(message.createdAt)}
                    </span>
                  </p>
                  {/*<div className={triangleClasses}></div>*/}
                </div>
               {/* <div className="bg-white flex items-center justify-center rounded-full m-1 h-10 w-10">
                  {isSender ? (
                    <div className="flex justify-center items-center border-[1px] bg-blue-400 border-gray-500 rounded-full sm:py-[7px] sm:px-[13px] py-1 px-[10px] mt-[120px]">
                      <Link to={`/profile/${message?.sender}`}>
                        <p className="sm:text-xl text-lg">
                          {message.senderFirstName?.charAt(0).toUpperCase()}
                        </p>
                      </Link>
                    </div>
                  ) : (
                    <div className="flex justify-center items-center border-[1px] bg-green-400 border-gray-500 rounded-full sm:py-[7px] sm:px-[13px] py-1 px-[10px] mt-[120px]">
                      <Link to={`/profile/${message?.sender}`}>
                        <p className="sm:text-xl text-lg">
                          {message.receiverFirstName?.charAt(0).toUpperCase()}
                        </p>
                      </Link>
                    </div>
                  )}
                </div>*/}
              </div>
            );
          })}
        </div>
      </div>
      {/* Input for sending messages */}
      <div className="flex items-center w-full border-t-[1px] md:relative bottom-0 fixed">
        <div>
          {imageUrl && imageUrl.length > 0 && (
            <div
              onClick={() => setImagePop(false)}
              className="relative m-2 w-11/12 ml-6 mb-6"
            >
              {isVideoExtension(imageUrl) === true ? (
                <video
                  className="w-full h-[100px] rounded-lg relative"
                  controls
                  autoPlay
                  loop
                  muted
                >
                  <source
                    src="https://savageseller.s3.amazonaws.com/380f8d1f-4e9e-4a33-9dbc-f1a7b6937ec2.mp4"
                    type="video/mp4"
                    alt="video"
                  />
                  Your browser does not support the video tag.
                </video>
              ) 
               
              : isPdfExtension(imageUrl) ? (
                          
                          <div className="flex flex-col items-center justify-center">
                          <img
                                      src={nopreview} // Display the first page image or a placeholder if the PDF image couldn't be generated
                                      alt={`PDF Document`}
                                      className="w-full h-32 object-cover cursor-pointer"
                                      onClick={() => window.open(imageUrl, "_blank")}
                                    />
                           
                          </div>
                        ): (
                <img
                  src={imageUrl}
                  alt="image"
                  className="w-full h-[100px] rounded-lg relative"
                />
              )}
              <span
                onClick={() => setImageUrl("")}
                className="absolute top-2 right-2 text-lg z-20 text-black border border-white rounded-full px-2  cursor-pointer bg-white"
              >
                X
              </span>
            </div>
          )}
        </div>

        <form
          className="w-full flex sm:m-6 mx-3 my-4 mb-6 relative"
          onSubmit={(e) => sendMessage(e)}
        >
          {/*<div className="button-container flex items-center absolute left-[5px] top-[12px]">
            <div className="emoji text-yellow-600 text-xl">
              <BsEmojiSmileFill onClick={handleEmojiPickerhideShow} />
              {showEmojiPicker && <Picker onEmojiClick={handleEmojiClick} />}
            </div>
          </div>*/}
          <input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className="flex-grow py-2 px-2 rounded-md border border-gray-400 w-11/12"
            placeholder="Type your message . . ."
          />
          <label
            htmlFor="fileInput"
            className={`${
              imageUrl && imageUrl.length > 0 ? "bg-green-500" : "bg-[#FAC63B]"
            } text-white cursor-pointer rounded mb-0 flex items-center px-2 py-[2px] ml-2`}
          >
            <MdAddPhotoAlternate className="text-4xl text-black" />
            <input
              id="fileInput"
              type="file"
              className="hidden"
              name="send_img"
                accept="image/jpeg, image/png, image/gif, video/*,application/pdf"
              onChange={(e) => {
                setImage(e);
              }}
            />
          </label>
          <button
            className={`${
              imageLoading === true ? "bg-green-500" : "bg-[#FAC63B]"
            } hover:bg-blue-700 text-black font-bold py-2 sm:px-4 px-3 rounded ml-2 sm:text-base text-sm`}
            type="button"
            onClick={sendMessage}
            disabled={imageLoading}
          >
            {imageLoading === true ? "Uploading . . ." : "Send"}
          </button>
        </form>
      </div>
    </div>
  );
};

const Chat = ({ onClose, sellerId, sellerName, sellerImage }) => {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const userData = decoded.data.customer_data;

  // Socket connection for Chat component
  const socket = io(config.API_BASE_URL, {
    transports: ["websocket", "polling"],
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  const [selectedChat, setSelectedChat] = useState(sellerId);


  const [selectedChatName, setSelectedChatName] = useState(sellerName);
  const [selectedChatImage, setSelectedChatImage] = useState(sellerImage);

  const [userList, setuserList] = useState([]);
  const [chatList, setchatList] = useState([]);

  const [isDesktopView, setIsDesktopView] = useState(window.innerWidth > 768);
  const handleResize = () => {
    setIsDesktopView(window.innerWidth > 768);
  };

  const [groupList, setGroupList] = useState([]);
  const [newGroupName, setNewGroupName] = useState("");
  const [groupMembers, setGroupMembers] = useState([]);
  const [chatType, setChatType] = useState("chat");
  const [getAllPublicGroup, setGetAllPublicGroup] = useState([]);
  const [getAllPrivateGroup, setGetAllPrivateGroup] = useState([]);
  const [privateGroupPop, setPrivateGroupPop] = useState(false);
  const [groupPassword, setGroupPassword] = useState("");
  const [groupId, setGroupId] = useState(null);

  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  console.log("private group ----------------->", getAllPrivateGroup);
  console.log("public group ----------------->", getAllPublicGroup);

  useEffect(() => {
    
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchChatsList = async () => {
    let senderId = "65d733f5b09518d5aed1b2a5";
    const toastId = "network-error-toast";
    const config = {
      url: `${config.API_BASE_URL}/bookings/getcustomerbookings/${userData.id}`,
      method: "GET",
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    try {
      const response = await axios.request(config);
      const data = response.data.data; // Make sure to access the correct property

      // Extract vendors from confirmed and upcoming bookings
      const confirmedVendors = data.Confirmed.map((booking) => ({
        vendorId: booking.sellerId,
        vendorName: booking.companyName,
        vendorContact: booking.vendorContact,
      }));
      const allVendors = data.All.map((booking) => ({
        vendorId: booking.sellerId,
        vendorName: booking.companyName,
        vendorContact: booking.vendorContact,
        lastMsg:booking.lastMsg,
        lastMsgdate:booking.lastMsgdate,
        seencount:booking.seenCount
      }));

      // Combine the two lists and remove duplicates based on vendorId
     // const allVendors = [...confirmedVendors, ...upcomingVendors];
      const uniqueVendors = Array.from(
        new Set(allVendors.map((v) => v.vendorId))
      ).map((id) => {
        return allVendors.find((v) => v.vendorId === id);
      });
 uniqueVendors.sort((a, b) => {
    const dateA = a.lastMsgdate ? new Date(a.lastMsgdate) : 0;
    const dateB = b.lastMsgdate ? new Date(b.lastMsgdate) : 0;
    return dateB - dateA; // Descending order
});
      setchatList(uniqueVendors); // Update the chat list state with unique vendors
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
        console.error('Network Connection Error:', error.message || error);
        if (!toast.isActive(toastId)) {
          toast.error('Unable to load messages due to a network issue. Please check your internet connection and try again.', {
            position: "top-center",
            autoClose: 3000,
            toastId: toastId, 
          });
        }
      } else {
        console.error('Error fetching messages:', error.message || error);
      }
    }
  };

  useEffect(() => {
    socket.on("receive-message", fetchChatsList);

    return () => {
      socket.off("receive-message", fetchChatsList);
    };
  }, []);
    useEffect(() => {
    //console.log("line>>>>",userData)
    socket.emit("register", userData.id);
    

    socket.on("disconnect", () => {
      console.log("Disconnected from the server");
    });

    return () => {};
  }, []);

  useEffect(() => {
   
    fetchChatsList();
  }, [selectedChat]);

  const senderId = userData?.id;
  const receiverId = selectedChat;
  const senderName = userData?.name;
  const receiverName = selectedChatName;

  const openChat = (receiverId, firstname, hero_img) => {
    setSelectedChat(receiverId);
    setSelectedChatName(firstname);
    setSelectedChatImage(hero_img);
  };

  const handleBackToChatList = () => {
    setSelectedChat(null);
    setSelectedChatName(null);
  };

  const [searchTerm, setSearchTerm] = useState("");
  // const [filteredUsers, setFilteredUsers] = useState([]);
  // const [selectedUser, setSelectedUser] = useState(null);
  // const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  // const [message, setMessage] = useState("");
  // const [newMessage, setNewMessage] = useState("");
  // const [groupname, setGroupname] = useState("");
  // const [loading, setloading] = useState(false);

  const filteredChatList = chatList.filter((user) => {
    return user.vendorName.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <div className="fixed md:h-[500px] absolute w-[400px] right-0 md:bottom-0 top-0">
      <button
        className="absolute top-0 right-0 text-[#000]   rounded-full h-8 w-8 flex items-center justify-center"
        onClick={onClose}
      >
        <IoCloseCircleOutline />
      </button>

      {selectedChat ? (
        <>
          {/* <button onClick={handleBackToChatList}>handleBackToChatList</button> */}
          <Chats
            data={{
              receiverId: selectedChat,

              senderId,
              senderName,
              receiverName,
              handleBackToChatList: handleBackToChatList,
              selectedChatImage: selectedChatImage,
            }}
          />
        </>
      ) : (
        <>
          <div className="flex flex-col w-full  border-r-2 overflow-y-auto transition-all duration-300 cursor-pointer h-full">
            <div className="border border-[1px]-gray-600 rounded-b-lg shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:bg-gray-300 transition-all duration-300 cursor-pointer">
              <div className="flex justify-between items-center border-b pb-3 p-3">
                <div className="flex justify-start items-center">
                  <div className="mx-2">
                    <div className="text-lg font-semibold">Messaging</div>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <input
                  type="text"
                  value={searchTerm}
                  placeholder="Search Kennel"
                  className="py-2 px-2 rounded-lg w-full border border-gray-400 bg-[#ECF7FF]"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  
                />
              </div>
            </div>
            <div className="h-full max-h-[90vh] overflow-y-auto">
            {chatType === 'chat' && filteredChatList.length > 0
        ? filteredChatList.map((user, index) => (
          <div
            className="flex px-5 py-[15px] hover:bg-[#E6EBF5] transition-all duration-300 cursor-pointer"
            onClick={() => {
              openChat(user.vendorId, user.vendorName, user.hero_img);setSearchTerm("")
            }}
            key={index}
          >
            <div className="relative self-center mr-3 border-[1px] border-gray-500 rounded-full p-1 bg-white">
              <FaRegUser
                className="rounded-full w-8 h-8 border-[1px] border-gray-500 bg-gray-300"
                alt=""
              />
            </div>

            <div className="flex-grow overflow-hidden">
              <h5 className="mb-1 font-semibold text-black">
                {user.vendorName}
              </h5>
              <p className="mb-0 text-gray-500 dark:text-gray-300 text-[14px] block w-40 overflow-hidden whitespace-nowrap overflow-ellipsis">
                {user.lastMsg?user?.lastMsg:""}
              </p>
            </div>
             <div className={`${user.seencount > 0 ? "text-[#1BB82A]" : "text-gray-500"} text-xs dark:text-gray-300 pt-1`}>

             {user?.lastMsgdate?
              GetDate(user?.lastMsgdate):""}<br />
             {user.seencount > 0 ? <p className="float-right"><span className="justify-center text-[#fff] bg-[#1BB82A] rounded-[100%] w-5 h-5 flex items-center">{user.seencount}</span></p>:""}
              </div>
          </div>
        ))
        : null
      }
    
              
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Chat;
